import { render, staticRenderFns } from "./ContentCreator.vue?vue&type=template&id=896eb11c&scoped=true"
import script from "./ContentCreator.vue?vue&type=script&lang=js"
export * from "./ContentCreator.vue?vue&type=script&lang=js"
import style0 from "./ContentCreator.vue?vue&type=style&index=0&id=896eb11c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896eb11c",
  null
  
)

export default component.exports